import clipboard from "@react-native-clipboard/clipboard";
import { Toast } from "components";

const copyToClipboard = (str: string) => {
  clipboard.setString(str);
  Toast.success({ message: "کپی شد" });
};

export default copyToClipboard;
